import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be within ThemeProvider');
  return ctx;
};

const THEME_CLASSES = {
  light: '',
  dark: 'dark',
  forest: 'theme-forest',
  ocean: 'theme-ocean',
  sunset: 'theme-sunset',
  midnight: 'theme-midnight dark',
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem('nl_theme');
    if (stored) return stored;
    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    // Remove all theme classes
    root.classList.remove('dark', 'theme-forest', 'theme-ocean', 'theme-sunset', 'theme-midnight');
    // Add the appropriate classes for the selected theme
    const classes = THEME_CLASSES[theme] || '';
    if (classes) {
      classes.split(' ').forEach(c => c && root.classList.add(c));
    }
    localStorage.setItem('nl_theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
